import React, { useCallback, useMemo } from 'react';
import { View, FlatList, } from 'react-native';
import { NativeViewGestureHandler } from 'react-native-gesture-handler';
import Text from 'design-system/Text';
import { rem } from 'design-system';
import useStyles from 'hooks/useStyles';
import FastImageCommon from 'common/FastImageCommon';
import createStyleSheets from 'utils/createStyleSheets';
import { getRewardTextToShow } from 'features/rewards/hooks/useRewards';
import TouchableBounce from 'utils/packages/TouchableBounce';
export const RewardCardWithCover = React.memo(({ reward, onPress, style }) => {
    const styles = useStyles(styleSet);
    return (<TouchableBounce onPress={() => onPress?.(reward)} hoverStyle={styles.hover}>
      <View style={[styles.cardContainer, style]}>
        <View style={styles.headerContainer}>
          <View style={styles.imgContainer}>
            <FastImageCommon url={{ uri: reward.imageUrl }} imageStyle={styles.image} resizeMode="cover"/>
          </View>
          <View style={styles.smallImageContainer}>
            <FastImageCommon resizeMode="cover" imageStyle={styles.smallImage} url={{
            uri: reward.partner.iconUrl && reward.partner.iconUrl !== "''"
                ? reward.partner.iconUrl
                : reward.imageUrl,
        }}/>
          </View>
        </View>
        <View style={styles.infoContainer}>
          <Text Text-16 numberOfLines={1}>
            {getRewardTextToShow(reward)}
          </Text>
        </View>
      </View>
    </TouchableBounce>);
});
RewardCardWithCover.displayName = 'RewardCardWithCover';
export const RewardsCarousel = React.memo(({ data, onPress, contentContainerStyle, paddingHorizontal }) => {
    const styles = useStyles(styleSet);
    const memoizedContentContainerStyle = useMemo(() => [
        styles.list,
        contentContainerStyle,
        { paddingHorizontal: (paddingHorizontal || 0) + rem(12) },
    ], [contentContainerStyle, paddingHorizontal, styles.list]);
    const renderItem = useCallback(({ item }) => <RewardCardWithCover reward={item} onPress={onPress}/>, [onPress]);
    return (<NativeViewGestureHandler disallowInterruption>
        <FlatList horizontal data={data} initialNumToRender={3} renderItem={renderItem} keyboardShouldPersistTaps="handled" showsHorizontalScrollIndicator={false} contentContainerStyle={memoizedContentContainerStyle}/>
      </NativeViewGestureHandler>);
});
RewardsCarousel.displayName = 'RewardsCarousel';
const CARD_WIDTH = rem(152);
const SMALL_IMAGE_SIZE = rem(36);
const styleSet = createStyleSheets((colors) => ({
    hover: {
        opacity: 0.8,
    },
    cardContainer: {
        width: CARD_WIDTH,
        borderRadius: rem(16),
        marginHorizontal: rem(4),
        backgroundColor: colors.cards.onDark,
    },
    list: {
        marginBottom: rem(8),
    },
    headerContainer: {
        width: '100%',
    },
    imgContainer: {
        width: '100%',
        aspectRatio: 152 / 146,
    },
    image: {
        width: '100%',
        height: '100%',
        borderRadius: rem(16),
    },
    infoContainer: {
        paddingHorizontal: rem(16),
        paddingVertical: rem(12),
        justifyContent: 'center',
    },
    smallImageContainer: {
        marginTop: -SMALL_IMAGE_SIZE / 2,
        marginLeft: rem(12),
        width: SMALL_IMAGE_SIZE,
        height: SMALL_IMAGE_SIZE,
    },
    smallImage: {
        width: '100%',
        height: '100%',
        borderWidth: rem(2),
        borderRadius: SMALL_IMAGE_SIZE,
        borderColor: colors.borders.logoStroke,
        backgroundColor: colors.background.logo,
    },
}));
